import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ConfigurationSettings } from "src/app/models/configuration.settings";
import { ToasterService } from "../../../services/shared/toaster/toaster.service";
import { FileuploadService } from "src/app/services/shared/fileupload/fileupload.service";
import { BotRegistrationService } from "src/app/services/core/bot-registration/bot-registration.service";
import { UtilityService } from "src/app/services/shared/utility/utility.service";
import { Subscription } from "rxjs";
import { IUserFileInfo } from "src/app/models/user-file-info";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material";
import { WarningPopupComponent } from "../../shared/warning-popup/warning-popup.component";
@Component({
  selector: "app-fileupload",
  templateUrl: "./fileupload.component.html",
  styleUrls: ["./fileupload.component.scss"],
})
export class FileUploadComponent implements OnInit {
  @ViewChild('fileChoose', { static: false }) fileChoose: ElementRef;
  file: File = null; // Variable to store file
  userRoles: string[] = [];
  superAdmin: boolean;
  fileToUpload: File = null;
  botList: any;
  botConfigId: number;
  rowData = [];
  columnDefs: any[] = [];
  userFileInfo: IUserFileInfo[] = [];
  showUploadBtn: boolean;
  showBrowseBtn: boolean;
  imageUrl: string;
  private gridApi;
  userData: any[] = [];
  closeResult = "";
  sortingOrder;
  defaultColDef;
  domLayout: string;
  paginationPageSize = 100;  
  private gridColumnApi;
  private _subscriptions = new Subscription();
  constructor(
    private httpClient: HttpClient,
    private configurationSetting: ConfigurationSettings,
    private toasterService: ToasterService,
    private fileuploadService: FileuploadService,
    private botRegistrationService: BotRegistrationService,
    private utilityService: UtilityService,
    private router: Router,
    private dialogWarning: MatDialog
  ) {}

  ngOnInit() {
    this.userRoles = sessionStorage.getItem("userRoles")
      ? sessionStorage.getItem("userRoles").split(",")
      : [];
    let superAdminUser = this.userRoles.find(
      (ob) =>
        ob.toLowerCase() === "superadmin" || ob.toLowerCase() === "super admin"
    );
    if (superAdminUser) {
      this.superAdmin = true;
    }

    this.domLayout = "autoHeight";
    this.showUploadBtn = false;
    this.showBrowseBtn = false;
    //Taking accessed bot list
    this.botRegistrationService.getRegisteredBots().subscribe(
      (res) => {
        sessionStorage.setItem("lastActiveTab", "utility");
        this.botList = this.setBotList(res);
        if (this.botList.length > 0) {
          this.botConfigId = this.botList[0].botConfigId;
        }
      },
      (error) => {
        this.toasterService.warn(
          "Unable to fetch BOT(s) details at the moment"
        );
      }
    );
  }

  createColumnDefs() {
    const customComparator = (valueA, valueB) => {
      valueA = valueA ? valueA : "";
      valueB = valueB ? valueB : "";
      return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
    };
    const columnDefs = [
      {
        headerName: "Image URL",
        field: "fileUri",
        width: 500,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Created Time",
        field: "createdTime",
        width: 150,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "View",
        width: 60,
        left: 637,
        cellRenderer: this.viewCellRenderer.bind(this),
      },
      {
        headerName: "Delete",
        width: 60,
        cellRenderer: this.deleteCellRenderer.bind(this),
      },
    ];
    this.columnDefs = columnDefs;
  }

  createRowData() {
    this.rowData =[];
    this._subscriptions.add(
      this.fileuploadService.GetAllUploadedFiles(this.botConfigId).subscribe(
        (res) => {
          this.userFileInfo = res;
          this.rowData = this.userFileInfo;
          this.createColumnDefs();
        },
        (error) => {
          this.toasterService.warn("No files found");
        }
      )
    );
  }

  viewCellRenderer(fileDetails: any) {
    const element = document.createElement("span");
    let cellValue = "View";
    let template =
      '<i class="fa fa-eye" aria-hidden="true" data-toggle="modal" data-target="#myModal" style="cursor: pointer;"></i>';
    element.innerHTML = template;
    element.addEventListener("click", (event) => {
    this.onViewFile(fileDetails.data.fileUri)
    }); 
    return element;
  }

  deleteCellRenderer(fileDetails: any) {
    const element = document.createElement("span");
    let template =
      '<i class="fa fa-trash" aria-hidden="true" style="cursor: pointer;"></i>';
    element.innerHTML = template;
    element.addEventListener("click", () => {
      //console.log(fileDetails.data);
      this.openWarning(fileDetails);
    });
    return element;
  }

  openWarning(fileDetails: any) {
    let dialogRef = this.dialogWarning.open(WarningPopupComponent, {
      height: "35%",
      width: "35%",
      autoFocus: false,
      data: fileDetails,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.createRowData();
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
  }

  setBotList(botlistResult) {
    let listOfBots = [];
    listOfBots.push({ botConfigId: -1, displayName: "-Select Bot-" });
    if (this.superAdmin) {
      botlistResult.forEach((item) => {
        listOfBots.push({
          botConfigId: item.botConfigId,
          displayName: item.displayName,
        });
      });
    } else {
      let botIds = this.utilityService.GetFeaturewiseBotList(
        sessionStorage.getItem("userBotRoles"),"FileUpload"
      );
      botlistResult.forEach((item) => {
        botIds.forEach((botConfigId) => {
          if (botConfigId == item.botConfigId) {
            listOfBots.push({
              botConfigId: item.botConfigId,
              displayName: item.displayName,
            });
          }
        });
      });
    }

    return listOfBots;
  }

  onBotChange(botConfigId) {
    if (botConfigId != -1) {
      this.botConfigId = botConfigId;
      this.showUploadBtn = false;
      this.showBrowseBtn = true;
      this.createRowData();
    } else {
      this.showBrowseBtn = false;
    }
  }
  onViewFile(url: string) {
    this.imageUrl = url;
  }

  onChange(event) {
    this.file = event.target.files[0];
    this.showUploadBtn = true;
  }

  // OnClick of button Upload
  onUpload() {
    this.fileuploadService
      .uploadFiletoServer(this.file, this.botConfigId)
      .subscribe(
        (res) => {
          this.toasterService.success("File successfuly uploaded");
          this.showUploadBtn = false;
          this.fileChoose.nativeElement.value = "";
          this.createRowData();
        },
        (error) => {
          this.toasterService.error("File upload failed");
        }
      );
  }
}
